<template>
  <div v-if="joboffer" class="job-details job-details__columns">
    <v-row>
      <v-col cols="12" lg="8">
        <div class="job-details__header-image">
          <header-images :images="joboffer.headerImages"></header-images>

          <div v-if="jobDetails" class="job-details__content-area">
            <h1 tabindex="0">{{ jobName }}</h1>

            <basics
              v-if="$vuetify.breakpoint.mdAndDown"
              :job-details="jobDetails"
              :joboffer="joboffer"
              :buttons="false"
            ></basics>

            <content-area :content="jobDetails.content"></content-area>

            <!-- <benefits :benefits="jobDetails.benefits"></benefits> -->

            <div
              v-if="jobDetails.showApplyButton"
              class="content-box text-center"
            >
              <h2 class="primary--text">{{ $t('jobs.applyPromptTitle') }}</h2>
              <p>
                {{ $t('jobs.applyPromptInfo') }}
              </p>
              <div class="mt-6">
                <job-buttons :joboffer="joboffer"></job-buttons>
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" lg="4" class="job-details__columns__right-col">
        <div class="job-details__columns__right-col__content">
          <basics
            v-if="$vuetify.breakpoint.lgAndUp"
            :joboffer="joboffer"
            :job-details="jobDetails"
            :block-buttons="
              $vuetify.breakpoint.smAndDown || $vuetify.breakpoint.lgAndUp
            "
          ></basics>

          <div
            v-if="
              jobDetails.showInternalContact &&
              localize(jobDetails.internalContactName)
            "
            class="content-box alternate job-details__contact-box"
            :class="{ 'content-box--has-top-image': showInternalContactPhoto }"
          >
            <div
              v-if="
                jobDetails.showInternalContactPhoto &&
                jobDetails.internalContactPhoto
              "
              class="content-box__top-image"
            >
              <v-img
                class="round-image"
                alt="Foto der internen Ansprechperson"
                :title="localize(jobDetails.internalContactName)"
                :src="`${baseUrl}${jobDetails.internalContactPhoto}`"
              />
            </div>
            <v-row class="content-box__content">
              <v-col cols="12">
                <p>
                  <strong>{{
                    localize(jobDetails.internalContactName)
                  }}</strong>
                  <template v-if="jobDetails.showInternalContactPosition">
                    <br />{{ localize(jobDetails.internalContactPosition) }}
                  </template>
                </p>

                <p>{{ localize(jobDetails.internalContactInfoText) }}</p>

                <div>
                  <v-btn
                    v-if="
                      jobDetails.showInternalContactPhone &&
                      jobDetails.internalContactPhone
                    "
                    small
                    class="mr-12 mb-2 mb-sm-4"
                    :href="`tel:${jobDetails.internalContactPhone}`"
                  >
                    {{ jobDetails.internalContactPhone }}
                    <v-icon class="append-icon">mdi-phone</v-icon>
                  </v-btn>

                  <div
                    v-if="
                      jobDetails.showInternalContactEmail &&
                      jobDetails.internalContactEmail
                    "
                  >
                    <v-btn
                      small
                      :href="`mailto:${jobDetails.internalContactEmail}`"
                    >
                      Mail
                      <v-icon class="append-icon">mdi-email-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <div
            v-if="jobDetails.showContact"
            class="content-box alternate job-details__contact-box"
            :class="{ 'content-box--has-top-image': showContactPhoto }"
          >
            <div
              v-if="jobDetails.showContactPhoto && jobDetails.contactPhoto"
              class="content-box__top-image"
            >
              <v-img
                class="round-image"
                alt="Foto der Ansprechperson"
                :title="localize(jobDetails.contactName)"
                :src="`${baseUrl}${jobDetails.contactPhoto}`"
              />
            </div>
            <v-row class="content-box__content">
              <v-col cols="12">
                <p>
                  <strong>{{ localize(jobDetails.contactName) }}</strong>
                  <template v-if="jobDetails.showContactPosition">
                    <br />{{ localize(jobDetails.contactPosition) }}
                  </template>
                </p>

                <p>{{ localize(jobDetails.contactInfoText) }}</p>

                <div>
                  <v-btn
                    v-if="
                      jobDetails.showContactPhone && jobDetails.contactPhone
                    "
                    small
                    class="mr-12 mb-2 mb-sm-4"
                    :href="`tel:${jobDetails.contactPhone}`"
                  >
                    {{ jobDetails.contactPhone }}
                    <v-icon class="append-icon">mdi-phone</v-icon>
                  </v-btn>

                  <div
                    v-if="
                      jobDetails.showContactEmail && jobDetails.contactEmail
                    "
                  >
                    <v-btn small :href="`mailto:${jobDetails.contactEmail}`">
                      Mail
                      <v-icon class="append-icon">mdi-email-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <div
            class="content-box content-box__dense alternate job-details__seal-images"
            v-if="jobDetails.sealImages && jobDetails.sealImages.length"
          >
            <div>
              <img
                v-for="(image, i) in jobDetails.sealImages"
                :key="`advert_seal_${i}`"
                :src="image.imageUrl"
                class="listing-image"
                :alt="localize(image.description)"
              />
            </div>
          </div>

          <div
            class="content-box content-box__dense alternate job-details__share-icons"
            v-if="hasSocialMediaLinks"
          >
            <ul class="job-details__share-icons-list">
              <li v-if="jobDetails.showFacebookLink && jobDetails.facebookUrl">
                <a
                  :href="jobDetails.facebookUrl"
                  target="_blank"
                  aria-label="Link zum Facebook-Profil"
                >
                  <img
                    v-if="hasCustomSocialMediaIcons"
                    :src="`${apiUrl}/file/public?slug=${slug}&fileName=facebook.svg`"
                    alt="Facebook Logo"
                  />
                  <v-icon v-else>$vuetify.icons.facebook</v-icon>
                </a>
              </li>

              <li
                v-if="jobDetails.showLinkedInLink && jobDetails.linkedInUrl"
              >
                <a
                  :href="jobDetails.linkedInUrl"
                  target="_blank"
                  aria-label="Link zum LinkedIn-Profil"
                >
                  <img
                    v-if="hasCustomSocialMediaIcons"
                    :src="`${apiUrl}/file/public?slug=${slug}&fileName=linkedin.svg`"
                    alt="LinkedIn Logo"
                  />
                  <v-icon v-else>$vuetify.icons.linkedin</v-icon>
                </a>
              </li>

              <li v-if="jobDetails.showXingLink && jobDetails.xingUrl">
                <a
                  :href="jobDetails.xingUrl"
                  target="_blank"
                  aria-label="Link zum Xing-Profil"
                >
                  <img
                    v-if="hasCustomSocialMediaIcons"
                    :src="`${apiUrl}/file/public?slug=${slug}&fileName=xing.svg`"
                    alt="Xing Logo"
                  />
                  <v-icon v-else>$vuetify.icons.xing</v-icon>
                </a>
              </li>

              <li
                v-if="
                  jobDetails.showInstagramLink && jobDetails.instagramUrl
                "
              >
                <a
                  :href="jobDetails.instagramUrl"
                  target="_blank"
                  aria-label="Link zum Instagram-Profil"
                >
                  <img
                    v-if="hasCustomSocialMediaIcons"
                    :src="`${apiUrl}/file/public?slug=${slug}&fileName=instagram.png`"
                    alt="Instagram Logo"
                  />
                  <v-icon v-else>$vuetify.icons.instagram</v-icon>
                </a>
              </li>

              <li v-if="jobDetails.showYouTubeLink && jobDetails.youTubeUrl">
                <a
                  :href="jobDetails.youTubeUrl"
                  target="_blank"
                  aria-label="Link zum YouTube-Profil"
                >
                  <img
                    v-if="hasCustomSocialMediaIcons"
                    :src="`${apiUrl}/file/public?slug=${slug}&fileName=youtube.svg`"
                    alt="YouTube Logo"
                  />
                  <v-icon v-else>$vuetify.icons.youtube</v-icon>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </v-col>
    </v-row>

    <div class="mobile-footer-content">
      <job-footer-buttons
        v-if="jobDetails.showApplyButton"
        :joboffer="joboffer"
        dense
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import basics from '@/components/jobDetails/job-basics-alt.vue';
import contentArea from '@/components/content/content-area.vue';
import jobFooterButtons from '@/components/jobDetails/job-footer-buttons.vue';
import jobButtons from '@/components/jobDetails/job-buttons.vue';
import headerImages from '@/components/jobDetails/job-header-images.vue';

export default {
  props: {
    apiUrl: {
      type: String,
      required: true
    },

    joboffer: {
      type: Object,
      required: true
    },

    jobDetails: {
      type: Object,
      required: true
    },

    slug: {
      type: String,
      required: true
    }
  },

  data: () => ({
    showBottomNav: true
  }),

  components: {
    basics,
    contentArea,
    headerImages,
    jobFooterButtons,
    jobButtons
  },

  computed: {
    ...mapState('companyModule', {
      baseUrl: 'baseUrl',
      hasCustomSocialMediaIcons: 'hasCustomSocialMediaIcons',
      companySlug: 'slug'
    }),

    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal'
    }),

    absoluteOverlay() {
      return true;
    },

    hasSocialMediaLinks() {
      return (
        (this.jobDetails.showFacebookLink && this.jobDetails.facebookUrl) ||
        (this.jobDetails.showLinkedInLink && this.jobDetails.linkedInUrl) ||
        (this.jobDetails.showXingLink && this.jobDetails.xingUrl) ||
        (this.jobDetails.showInstagramLink && this.jobDetails.instagramUrl) ||
        (this.jobDetails.showYouTubeLink && this.jobDetails.youTubeUrl)
      );
    },

    showContactPhoto() {
      return this.jobDetails.showContactPhoto && this.jobDetails.contactPhoto;
    },

    jobName() {
      return this.isInternal
        ? this.localize(this.joboffer.internalName) || this.localize(this.joboffer.name)
        : this.localize(this.joboffer.name);
    },
  },

  created() {
    this.$route.meta.hasScrollMenu = false;
  }
};
</script>
